import { FormControl, InputLabel, MenuItem, Paper, Select, Stack } from "@mui/material";
import useTeams from "../../hooks/useTeams.ts";
import usePricingManagementStore from "../../../stores/pricing-management.store.ts";

const ALL_TEAM_TAG = "All teams"

export function TeamSelector() {
  const { getAllTeams } = useTeams();
  const { selectedTeam, setSelectedTeam } = usePricingManagementStore();
  
  const teams =  getAllTeams();
  if (teams.length <= 1) return null;

  function onTeamChange(teamId: string) {
    if (teamId === ALL_TEAM_TAG) return setSelectedTeam(undefined);
    const team = teams.find(x => x.teamId === teamId);
    setSelectedTeam(team);
  }

  return (
    <Paper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        m={1}
      >
        <FormControl fullWidth sx={{ m: 1 }}>
          <InputLabel>Selected Team</InputLabel>
          <Select
            value={selectedTeam ? selectedTeam.teamId : ALL_TEAM_TAG}
            label="Selected Team"
            size="small"
            onChange={e => onTeamChange(e.target.value)}
          >
            <MenuItem value={ALL_TEAM_TAG}>All teams</MenuItem>
            {teams.map((team) => (
              <MenuItem key={team.teamId} value={team.teamId}>{team.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Paper>
  );
}
